import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import { Flex } from 'reflexbox'

import HorizontalTableConfig from './HorizontalTableConfig'

import styles from './styles.scss'


class HorizontalTableInput extends Component {
  render() {
    const {
      values,
      horizontalTableAdd,
      horizontalTableRemove,
      horizontalTableUpdate,
      horizontalTableNestedAdd,
      horizontalTableNestedRemove,
      horizontalTableNestedUpdate,
      rowFormat,
      elementKey
    } = this.props

    return (
      <Flex styleName="HorizontalTableWrapper">
        <HorizontalTableConfig
          values={values}
          onAdd={horizontalTableAdd}
          onRemove={horizontalTableRemove}
          onUpdate={horizontalTableUpdate}
          onNestedAdd={horizontalTableNestedAdd}
          onNestedRemove={horizontalTableNestedRemove}
          onNestedUpdate={horizontalTableNestedUpdate}
          rowFormat={rowFormat}
          elementKey={elementKey}
        />
      </Flex>
    )
  }
}

export default CSSModules(HorizontalTableInput, styles)
